export function capitalize(str: string): string {
    if (str === undefined || str === null || str.length === 0) {
        return str;
    }

    let capitalized: string = str.charAt(0).toUpperCase();

    if (str.length > 1) {
        capitalized += str.slice(1);
    }

    return capitalized;
}
